module.exports = __webpack_public_path__ + "img/BannerNewMultihogar.c4841665.jpg";